import React from "react";
import {
  FaArrowRight,
  FaDroplet,
  FaGear,
  FaHelmetSafety,
  FaScrewdriverWrench,
  FaSolarPanel,
  FaTowerObservation,
  FaWater,
} from "react-icons/fa6";
import Reveal from "./Reveal";
import { trackEvent } from "../lib/analytics";

// TODO: revisar y ajustar las descripciones — son un primer borrador basado en
// los servicios que ya mencionaba el sitio.
const services = [
  {
    icon: FaTowerObservation,
    title: "Pivotes centrales",
    text: "Provisión, montaje y puesta en marcha de equipos de pivote central. Diseñamos el sistema según la superficie, el cultivo y el caudal disponible.",
  },
  {
    icon: FaWater,
    title: "Riego por aspersión",
    text: "Cañones y aspersores para cobertura uniforme en superficies grandes, con la presión adecuada para cada terreno.",
  },
  {
    icon: FaDroplet,
    title: "Riego por goteo",
    text: "Sistemas de alta eficiencia que llevan el agua directo a la raíz. Menor consumo, menos evaporación y mejor aprovechamiento del recurso.",
  },
  {
    icon: FaGear,
    title: "Alas regadoras",
    text: "Equipos de avance frontal y alas regadoras para lotes de geometría irregular.",
  },
  {
    icon: FaSolarPanel,
    title: "Bombas de riego solares",
    text: "Sistemas de bombeo con energía solar para lotes sin acceso a la red eléctrica: sin costo de combustible ni de conexión.",
  },
  {
    icon: FaScrewdriverWrench,
    title: "Repuestos y service",
    text: "Stock de repuestos de las marcas que representamos, mantenimiento preventivo y reparación de equipos ya instalados.",
  },
  {
    icon: FaHelmetSafety,
    title: "Proyecto y asesoramiento",
    text: "Analizamos su caso, calculamos la necesidad hídrica y le proponemos la solución que mejor se ajusta al presupuesto y al objetivo productivo.",
  },
];

const Services = () => {
  return (
    <section id="servicios" className="bg-slate-50 py-20 sm:py-28">
      <div className="container-site">
        <Reveal className="max-w-2xl">
          <p className="section-eyebrow">Qué hacemos</p>
          <h2 className="section-title">
            Soluciones de riego llave en mano
          </h2>
          <p className="section-lead">
            Acompañamos el proyecto de punta a punta: desde el relevamiento y el
            cálculo hasta la instalación, la puesta en marcha y el service
            posterior.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
            const Icon = service.icon;
            return (
              <Reveal key={service.title} delay={i * 70}>
                <article className="group h-full rounded-2xl border border-slate-200/80 bg-white p-7 shadow-card transition-all duration-300 hover:-translate-y-1 hover:border-campo-200 hover:shadow-card-hover">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-campo-50 text-campo-700 transition-colors duration-300 group-hover:bg-campo-700 group-hover:text-white">
                    <Icon size={20} aria-hidden="true" />
                  </span>
                  <h3 className="mt-5 text-lg">{service.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-600">
                    {service.text}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={120} className="mt-12 flex justify-center">
          <a
            href="#contacto"
            onClick={() => trackEvent("cta_click", { location: "services" })}
            className="group inline-flex items-center gap-2 text-sm font-semibold text-campo-700 transition-colors hover:text-campo-900"
          >
            ¿No encontrás lo que buscás? Consultanos tu caso
            <FaArrowRight
              size={13}
              aria-hidden="true"
              className="transition-transform duration-200 group-hover:translate-x-1"
            />
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default Services;
